import React, { useContext, useEffect, useLayoutEffect, useRef } from "react";
import "./App.css";
import { ThemeProvider } from "react-jss";
import { ReactNotifications } from "react-notifications-component";
import { useFullscreen } from "react-use";
import { Route, Routes, useLocation } from "react-router-dom";
import { ToastProvider } from "react-toast-notifications";
import ThemeContext from "../contexts/themeContext";
import Aside from "../layout/Aside/Aside";
import Wrapper from "../layout/Wrapper/Wrapper";
import Portal from "../layout/Portal/Portal";
import { layoutPages } from "../menu";
import { Toast, ToastContainer } from "../components/bootstrap/Toasts";
import useDarkMode from "../hooks/useDarkMode";
import COLORS from "../common/data/enumColors";
import { getOS } from "../helpers/helpers";
import ProviderContext from "../ProviderContext/ProviderContext";

const App = () => {
  getOS();
  const { themeStatus, darkModeStatus } = useDarkMode();
  const location = useLocation();
  const theme = {
    theme: themeStatus,
    primary: COLORS.PRIMARY.code,
    secondary: COLORS.SECONDARY.code,
    success: COLORS.SUCCESS.code,
    info: COLORS.INFO.code,
    warning: COLORS.WARNING.code,
    danger: COLORS.DANGER.code,
    dark: COLORS.DARK.code,
    light: COLORS.LIGHT.code,
  };

  useEffect(() => {
    if (darkModeStatus) {
      document.documentElement.setAttribute("theme", "dark");
    }
    return () => {
      document.documentElement.removeAttribute("theme");
    };
  }, [darkModeStatus]);
  const { fullScreenStatus, setFullScreenStatus } = useContext(ThemeContext);
  const ref = useRef(null);

  useFullscreen(ref, fullScreenStatus, {
    onClose: () => setFullScreenStatus(false),
  });

  useLayoutEffect(() => {
    if (process.env.REACT_APP_MODERN_DESGIN === "true") {
      document.body.classList.add("modern-design");
    } else {
      document.body.classList.remove("modern-design");
    }
  });
  const withOutAsidePages = [
    layoutPages.login.path,
    layoutPages.signUp.path,
    layoutPages.live_tv.path,
  ];

  return (
    <ProviderContext>
      <ThemeProvider theme={theme}>
        <ToastProvider components={{ ToastContainer, Toast }}>
          <div
            ref={ref}
            className="app"
            style={{
              backgroundColor: fullScreenStatus && "var(--bs-body-bg)",
              zIndex: fullScreenStatus && 1,
              overflow: fullScreenStatus && "scroll",
            }}
          >
            <Routes>
              {withOutAsidePages.map((path) => (
                <Route key={path} path={path} />
              ))}
              <Route path="*" element={<Aside />} />
            </Routes>
            <Wrapper pathname={{ routeName: location.pathname }} />
          </div>
          <Portal id="portal-notification">
            <ReactNotifications />
          </Portal>
        </ToastProvider>
      </ThemeProvider>
    </ProviderContext>
  );
};

export default App;
